import { controller } from "./controller";

@controller
export default class RadioButtonElement extends HTMLElement {
  input: HTMLInputElement | undefined | null;
  label: HTMLLabelElement | undefined | null;

  connectedCallback(): void {
    // eslint-disable-next-line custom-elements/no-dom-traversal-in-connectedcallback
    this.input = this.querySelector("input");
    // eslint-disable-next-line custom-elements/no-dom-traversal-in-connectedcallback
    this.label = this.querySelector("label");
    if (this.input && this.label) {
      this.input.name = "ServiceAddress";
      this.pretifyAddress();
      this.label.setAttribute("class", "address-radio-wrapper");
    }
  }

  pretifyAddress(): void {
    this.input
      ?.getAttribute("selectedvalue")
      ?.split("#")
      .map((line, index) => {
        const span = document.createElement("span");
        index === 0
          ? span.setAttribute("class", "address-radio-title")
          : span.setAttribute("class", "address-radio-subtitle");
        span.appendChild(document.createTextNode(line));
        this.label?.appendChild(span);
      });
  }
}

declare global {
  interface Window {
    RadioButtonElement: typeof RadioButtonElement;
  }
  interface HTMLElementTagNameMap {
    "radio-button": RadioButtonElement;
  }
}

if (!window.customElements.get("radio-button")) {
  window.RadioButtonElement = RadioButtonElement;
  window.customElements.define("radio-button", RadioButtonElement);
}
